// Stubble & Co — trilhos, hover hero e abas
(function () {
  function rails(root) {
    root.querySelectorAll('[data-sc-rail]').forEach(function (r) {
      if (r.dataset.ok) return; r.dataset.ok = 1;
      var nav = r.parentElement.querySelector('.sc-railnav'); if (!nav) return;
      var prev = nav.querySelector('[data-sc-prev]'), next = nav.querySelector('[data-sc-next]'), bar = nav.querySelector('[data-sc-progress]');
      function step() { var c = r.firstElementChild; return c ? c.getBoundingClientRect().width + 8 : r.clientWidth; }
      function upd() {
        var max = r.scrollWidth - r.clientWidth; prev.disabled = r.scrollLeft <= 2; next.disabled = r.scrollLeft >= max - 2;
        var vis = r.clientWidth / r.scrollWidth; bar.style.width = (vis * 100) + '%'; bar.style.left = (max > 0 ? (r.scrollLeft / max) * (100 - vis * 100) : 0) + '%';
      }
      prev.addEventListener('click', function () { r.scrollBy({ left: -step(), behavior: 'smooth' }); });
      next.addEventListener('click', function () { r.scrollBy({ left: step(), behavior: 'smooth' }); });
      r.addEventListener('scroll', upd, { passive: true }); window.addEventListener('resize', upd); upd();
    });
    root.querySelectorAll('[data-sc-hover]').forEach(function (h) {
      var imgs = h.querySelectorAll('.sc-hover__img'); if (!imgs.length) return;
      function show(i) { imgs.forEach(function (im, k) { im.classList.toggle('is-on', k === i); }); }
      show(0);
      h.querySelectorAll('.sc-hover__pills [data-i]').forEach(function (a) { a.addEventListener('mouseenter', function () { show(+a.dataset.i); }); });
    });
    root.querySelectorAll('[data-sc-tabs]').forEach(function (t) {
      t.querySelectorAll('[data-go]').forEach(function (b) {
        b.addEventListener('click', function () { t.querySelectorAll('.sc-mission__panel').forEach(function (p) { p.classList.toggle('is-on', p.dataset.tab === b.dataset.go); }); });
      });
    });
  }
  document.addEventListener('DOMContentLoaded', function () { rails(document); });
  document.addEventListener('shopify:section:load', function (e) { rails(e.target); });
})();
